export function setContrast(color) {
  if (!color) {
    return color;
  }
  const textColor = convertHex(color);
  const [r, g, b] = textColor.match(/\d+/g).map(Number);

  const luminance = 0.2126 * r + 0.7152 * g + 0.0722 * b;

  return luminance > 128 ? "#333333" : "#f4f3f2";
}

function convertHex(hex) {
  hex = hex.replace(/^#/, "");

  let r, g, b;
  if (hex.length === 3) {
    r = parseInt(hex[0] + hex[0], 16);
    g = parseInt(hex[1] + hex[1], 16);
    b = parseInt(hex[2] + hex[2], 16);
  } else if (hex.length === 6) {
    r = parseInt(hex.substring(0, 2), 16);
    g = parseInt(hex.substring(2, 4), 16);
    b = parseInt(hex.substring(4, 6), 16);
  } else {
    throw new Error("Invalid hex color format");
  }

  return `rgb(${r}, ${g}, ${b})`;
}
